import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';
import { useAuthStore } from './stores/authStore';
import { TranslationProvider } from './context/TranslationContext';

// 初始化用户状态
const InitializeAuth = ({ children }: { children: React.ReactNode }) => {
  const { token, fetchUser } = useAuthStore();
  const [isInitializing, setIsInitializing] = React.useState(true);
  
  React.useEffect(() => {
    const init = async () => {
      if (token) {
        try {
          await fetchUser();
        } catch (error) {
          console.error('初始化用户失败:', error);
        }
      }
      setIsInitializing(false);
    };
    
    init();
  }, [token, fetchUser]);
  
  if (isInitializing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">加载中...</p>
        </div>
      </div>
    );
  }
  
  return <>{children}</>;
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <InitializeAuth>
        <TranslationProvider>
          <App />
          <Toaster
            position="top-center"
            toastOptions={{
              duration: 3000,
              style: {
                background: '#333',
                color: '#fff',
              },
              success: {
                iconTheme: {
                  primary: '#10b981',
                  secondary: '#fff',
                },
              },
              error: {
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#fff',
                },
              },
            }}
          />
        </TranslationProvider>
      </InitializeAuth>
    </BrowserRouter>
  </React.StrictMode>
);
